import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HandleErrorService {
  public handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      // tslint:disable-next-line
      msg = `An error occurred: ${error.error.message}`;
      console.error(msg);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      msg = `Backend returned code ${error.status}, ` +
      `body was: ${error.error}`;
      console.error(msg);
    }
    return msg;
    // return an observable with a user-facing error message
    // return throwError(
    //   'Something bad happened; please try again later.');
  }
}

